<template>
  <span class="split-ellipsis">
    <span class="split-ellipsis__head text-truncate">{{ head }}</span>
    <span v-if="tail" class="split-ellipsis__tail">{{ tail }}</span>
  </span>
</template>

<script>
export default {
  name: "SplitEllipsis",
  props: {
    text: {
      type: String,
      required: true,
    },
    splitIndex: {
      type: Number,
      required: true,
    },
  },
  computed: {
    hasSplit() {
      return this.splitIndex >= 0;
    },
    head() {
      return this.hasSplit ? this.text.slice(0, this.splitIndex) : this.text;
    },
    tail() {
      return this.hasSplit ? this.text.slice(this.splitIndex) : "";
    },
  },
};
</script>

<style lang="scss">
.split-ellipsis {
  display: flex;
  max-width: 100%;
  width: fit-content;

  &__head {
    min-width: 0;
  }

  &__tail {
    flex: none;
    white-space: nowrap;
  }
}
</style>
